import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getMaster } from './firebase';
import {
  STATUS_IDLE,
  STATUS_FETCHING,
  STATUS_ERROR,
  STATUS_READY
} from './constants';

export const fetchDivision = createAsyncThunk('fetchDivision', async () => await getMaster('divisions'));

const divisionSlice = createSlice({
  name: 'division',
  initialState: {
    status: STATUS_IDLE,
    data: null
  },
  reducers: {},
  extraReducers (builder) {
    builder
      .addCase(fetchDivision.pending, (state, action) => {
        state.status = STATUS_FETCHING
      })
      .addCase(fetchDivision.fulfilled, (state, action) => {
        state.status = STATUS_READY
        state.data = action.payload
      })
      .addCase(fetchDivision.rejected, (state, action) => {
        state.status = STATUS_ERROR
        state.error = action.error.message
      })
  }
})

export default divisionSlice.reducer
